import {
  LinkedinFilled,
  SyncOutlined,
  SearchOutlined,
  StarFilled,
  CompassOutlined,
  UnlockOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  RocketOutlined,
  BankOutlined,
} from "@ant-design/icons";
import anonymous from "../Assets/Images/logo.svg";
import indicate from "../Assets/Icons/indicate.svg";
import match from "../Assets/Icons/match.svg";
import icon1 from "../Assets/Icons/employer1.svg";
import icon2 from "../Assets/Icons/employer2.svg";
import icon3 from "../Assets/Icons/employer3.svg";
import icon4 from "../Assets/Icons/employer4.svg";
import icon5 from "../Assets/Icons/employer5.svg";
import icon6 from "../Assets/Icons/employer6.svg";
import icon7 from "../Assets/Icons/employer7.svg";
import icon8 from "../Assets/Icons/employer8.png";
import icon9 from "../Assets/Icons/employer9.png";
import icon10 from "../Assets/Icons/swing.png";
import icon11 from "../Assets/Icons/daversa.jpeg";
import icon12 from "../Assets/Icons/partner.jpeg";
import icon13 from "../Assets/Icons/inflection.png";

export const anonimityCards = [
  {
    icon: anonymous,
    title:
      "Upon approval, complete your anonymous profile or confidential job opportunity",
  },
  {
    icon: indicate,
    title: "Indicate interest on the candidate or job opportunity",
  },
  {
    icon: match,
    title: "Match with exclusive opportunities & top talent",
  },
];

export const trustedEmployers = [
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  icon7,
  icon8,
  icon9,
  icon10,
  icon11,
  icon12,
  icon13,
];

export const carouselConfig = [
  {
    text: "1Stealth Jobs adds a layer of precision to our executive recruitment efforts. The exclusive access to high-caliber candidates and the platform's commitment to anonymity make it stand out. The reduction in hiring biases aligns with our values, creating a positive impact on our recruitment outcomes. Stealth Jobs is the place we proactively source for backfills, opportunistic hires, and confidential executive searches.",
    name: "David",
    position: "Senior Executive",
    profile: "Recruiter",
  },
  {
    text: "2Stealth Jobs adds a layer of precision to our executive recruitment efforts. The exclusive access to high-caliber candidates and the platform's commitment to anonymity make it stand out. The reduction in hiring biases aligns with our values, creating a positive impact on our recruitment outcomes. Stealth Jobs is the place we proactively source for backfills, opportunistic hires, and confidential executive searches.",
    name: "Sarah",
    position: "Senior Executive",
    profile: "Job seeker",
  },
  {
    text: "3Stealth Jobs adds a layer of precision to our executive recruitment efforts. The exclusive access to high-caliber candidates and the platform's commitment to anonymity make it stand out. The reduction in hiring biases aligns with our values, creating a positive impact on our recruitment outcomes. Stealth Jobs is the place we proactively source for backfills, opportunistic hires, and confidential executive searches.",
    name: "Sarah",
    position: "Senior Executive",
    profile: "Job seeker",
  },
  {
    text: "4Stealth Jobs adds a layer of precision to our executive recruitment efforts. The exclusive access to high-caliber candidates and the platform's commitment to anonymity make it stand out. The reduction in hiring biases aligns with our values, creating a positive impact on our recruitment outcomes. Stealth Jobs is the place we proactively source for backfills, opportunistic hires, and confidential executive searches.",
    name: "David",
    position: "Senior Executive",
    profile: "Recruiter",
  },
];

export const mobileNavMenuItems = [
  { label: "For Talent", link: "/#built-for-talent" },
  { label: "For Recruiters", link: "/#built-for-hiring-teams" },
  { label: "How It Works", link: "/#how-it-works" },
  { label: "FAQ", link: "/#faq" },
  { label: "Newsletter", link: "/newsletter" },
];

export const whyWeBuiltStaticText = [
  "Having embarked on a journey to explore a new leadership position, I faced challenges that led to the creation of Stealth Jobs—a solution crafted to optimize the confidential hiring process.",
  "In this exploration, finding available leadership opportunities on the most common job boards proved challenging. Instead of being able to easily identify open roles, I resorted to extensive networking, meeting with over 100 professionals, including executive recruiters, talent partners, venture partners, founders, and executives. Quickly, I realized that this networking was the sole means to discover leadership positions as ~90% of all available leadership roles were confidential and not publicly visible online for qualified candidates to indicate interest. This not only hindered my proactive search for opportunities but also highlighted the significant challenge for more passive or confidential candidates.",
  "Stealth Jobs was born out of this need for a better way—a curated platform providing exclusive access to a hidden list of opportunities that meets your specific criteria. With a key emphasis on confidentiality, both candidates and hiring companies remain anonymous until a mutual match is established. This ensures that passive and opportunistic candidates can explore opportunities with confidence, maintaining anonymity, while also supporting employers with highly confidential roles such as crucial hires, strategic initiatives, sensitive backfills, and more.",
  "Our goal is to introduce efficiency, confidentiality, and inclusivity to the hiring process. By fostering a secure environment where professionals can explore opportunities and companies have the ability to source active or passive candidates for highly confidential roles, we aim to significantly reduce the hiring timeline from months to weeks, facilitating meaningful connections between candidates and their next opportunity.",
];

// ---------------------------------------------------------------------------
// "Confidentially Connect Top Talent and Breakout Companies" homepage (revised design)
// ---------------------------------------------------------------------------

const roleAboutBullets = [
  "Own the revenue function, guiding the company's growth in enterprise software.",
  "Build channel partnerships and strategic relationships that drive the sales organization",
  "Codify the sales process and build the team that will scale it",
  "Partner directly with the CEO and COO on GTM strategy",
];

// The chips a candidate sees on a job card in the product, in the same order
// (salary, location type, employment type, industry, company ARR, company
// stage), using the product's own option labels.
const rolePreferences = [
  "$400K–$500K",
  "Hybrid",
  "Full Time",
  "Enterprise",
  "$10M–$50M ARR",
  "Series C",
];

const roleSummary = {
  title: "SVP of Sales",
  location: "New York, NY",
  tags: rolePreferences,
  aboutHeading: "About the role",
  bullets: roleAboutBullets,
};

// Mirrors what a recruiter actually sees in the product: masked name, location,
// seniority and function, and role history. Identity unlocks on a mutual match.
//
// Tags are the candidate's experience level and job function. Comp, location
// type and employment type are preferences, not things that describe the
// person, so they stay off this card. Each role shows ARR, headcount and dates,
// the accomplishments from the role description, and the type of company as
// sector + stage. The company type is what a recruiter gets in place of the
// hidden company name. Both come from the Firsthand Partners attributes lists:
// sectors (Aerospace & Defense ... Hospitality) and stages (Pre-Seed ...
// Series D+, PE-Backed, Public Company). Use only values from those lists.
// Nothing here may name the company — this card is visible before a match.
const candidateProfile = {
  location: "New York, NY",
  tags: ["VP/Sr. VP", "Sales & Business Development"],
  experienceHeading: "Experience",
  experience: [
    {
      title: "VP of Sales",
      companyType: ["Cybersecurity", "Series D+"],
      meta: "$50M–$100M ARR · 501–1000 employees · 2021–Present",
      highlights: [
        "Grew ARR from $10M to $100M in three years",
        "Built a 45-person sales org across NA and EMEA",
      ],
    },
    {
      title: "Senior Director of Sales",
      companyType: ["FinTech", "Series A"],
      meta: "$0M–$10M ARR · 51–200 employees · 2018–2021",
      highlights: [
        "Took the company from $2M to $9M ARR",
        "Hired and led the first enterprise sales team",
      ],
    },
  ],
};

// Drives the interactive "LIVE DEMO" — Two Perspectives, One Seamless Match section.
export const liveDemoSteps = [
  {
    id: "before-interest",
    label: "Before Interest",
    columnSubtext: {
      leader: "A confidential role — company identity hidden",
      recruiter: "No candidates yet — pipeline unlocks when a candidate acts",
    },
    leader: {
      ...roleSummary,
      footerBadge: "Confidential Role",
      actionLabel: "Indicate Interest",
      actionState: "default",
      note: "Until you indicate interest, you can't contact or be contacted — and the company can't see you.",
    },
    recruiter: {
      footerBadge: "Anonymous Candidate",
      state: "locked",
      heading: "No interested candidates yet",
      copy: "Candidates surface only when they choose to indicate interest in your specific role.",
      note: "Interest-verified candidates only — every candidate you see has opted in to your role. No cold outreach, no guessing.",
    },
  },
  {
    id: "interest-indicated",
    label: "Interest Indicated",
    columnSubtext: {
      leader: "Interest sent — your identity is still hidden",
      recruiter: "An anonymized candidate — identity unlocks after mutual interest",
    },
    leader: {
      ...roleSummary,
      footerBadge: "Confidential Role",
      actionLabel: "Interest Sent",
      actionState: "sent",
      note: "The company can now see your anonymized profile. Your name and current employer stay hidden until there's mutual interest.",
    },
    recruiter: {
      footerBadge: "Anonymous Candidate",
      state: "candidate",
      profile: { ...candidateProfile, nameRevealed: false },
      note: "Candidate name is revealed when matched.",
      actionLabel: "Express Interest",
    },
  },
  {
    id: "mutual-match",
    label: "Mutual Match",
    columnSubtext: {
      leader: "It's a match — company identity revealed",
      recruiter: "It's a match — candidate identity revealed",
    },
    leader: {
      ...roleSummary,
      title: "SVP of Sales @ Northwind Cloud",
      footerBadge: "Identity Revealed",
      actionLabel: "Schedule Interview",
      actionState: "matched",
      note: "It's a match! Full profiles are visible to both sides — time to schedule the first conversation.",
    },
    recruiter: {
      footerBadge: "Identity Revealed",
      state: "matched",
      profile: {
        ...candidateProfile,
        nameRevealed: true,
        name: "Jordan M.",
        currentRole: "VP of Sales, Meridian SaaS",
      },
      note: "It's a match! Full profiles are visible to both sides — time to schedule the first conversation.",
      actionLabel: "Schedule Interview",
    },
  },
];

// "Non\u2011Stealth" uses a non-breaking hyphen so the word never splits as
// "Non-" / "Stealth" across two lines.
export const builtForLeadersCards = [
  {
    number: "01",
    badge: "Secure Login",
    icon: <LinkedinFilled />,
    title: "Easy LinkedIn login & account connection",
    description:
      "Get started in minutes with a simple, secure onboarding process.",
  },
  {
    number: "02",
    icon: <SyncOutlined />,
    title: "Stealth or Non\u2011Stealth profile",
    description:
      "Choose Stealth to keep your name, company, and photo hidden until a mutual match, or Non\u2011Stealth to share them when you indicate interest in a role.",
  },
  {
    number: "03",
    icon: <SearchOutlined />,
    title: "Curated, non-public roles",
    description:
      "Access opportunities aligned with your experience that aren't posted publicly.",
  },
  {
    number: "04",
    icon: <StarFilled />,
    title: "Signal interest in one-click",
    description: "Only talk to serious opportunities with mutual interest.",
  },
];

export const hiringTeamFeatureCards = [
  {
    icon: <UnlockOutlined />,
    title: "Stealth or Non\u2011Stealth job postings",
    description:
      "Turn on Stealth Mode to keep your company name private until a match, protecting your hiring strategy, or post openly when discretion isn't needed.",
  },
  {
    icon: <SearchOutlined />,
    title: "Less noise, better signal",
    description:
      "Focus on a curated shortlist of serious candidates who are truly interested.",
  },
];

// Follows the process published on stealthjobs.co:
// approve & go anonymous -> indicate interest -> match.
export const howItWorksSteps = {
  leaders: [
    {
      icon: <CheckCircleOutlined />,
      title: "Get Approved & Choose Your Visibility",
      description:
        "Apply once. After approval, set up your profile as Stealth to keep your name and current company hidden until a match, or Non\u2011Stealth to show them to the companies you're interested in.",
    },
    {
      icon: <CompassOutlined />,
      title: "Indicate Interest",
      description:
        "Browse curated roles and indicate interest in the ones you want. Companies only see you once you do.",
    },
    {
      icon: <UnlockOutlined />,
      title: "Match & Reveal",
      description:
        "When interest is mutual, it's a match — any hidden identities are revealed and the conversation begins.",
    },
  ],
  recruiters: [
    {
      icon: <FileTextOutlined />,
      title: "Get Approved & Post Your Role",
      description:
        "After approval, post your role in Stealth Mode to keep your company name hidden, or post it openly.",
    },
    {
      icon: <SearchOutlined />,
      title: "Indicate Interest",
      description:
        "Review candidates who've opted in to your role, and indicate interest in the right fit.",
    },
    {
      icon: <UnlockOutlined />,
      title: "Match & Reveal",
      description:
        "When interest is mutual, it's a match — both sides see full profiles and move to interviews.",
    },
  ],
};

export const revisedFaqConfig = [
  {
    id: 1,
    heading: "What is Stealth Jobs for candidates?",
    text: "Stealth Jobs is a confidential platform that gives high-slope GTM and technical talent exclusive access to a curated list of hidden opportunities at breakout companies. You control what's visible and to whom, so you can explore your next move without tipping off your current employer or network.",
  },
  {
    id: 2,
    heading: "How do you protect my identity while I explore new roles?",
    text: "You choose whether your profile is Stealth or Non-Stealth. In Stealth, your name and current company stay hidden from employers until a match is formed. Either way, nothing moves forward until you indicate interest in a specific role and that interest is mutual.",
  },
  {
    id: 3,
    heading: "Will my current company see that I'm on Stealth Jobs?",
    text: "No. We block visibility into roles from your current and past employers, so a match with them isn't possible, and your activity on the platform is never shared outside of a confirmed mutual match.",
  },
  {
    id: 4,
    heading: "What types of roles will I see?",
    text: "You'll see curated, largely non-public roles at breakout companies — spanning GTM and technical teams, from senior individual contributor through executive — matched to the job functions, seniority, and preferences on your profile.",
  },
  {
    id: 5,
    heading: "What is Stealth Jobs for recruiters?",
    text: "Stealth Jobs gives hiring teams a private channel to source vetted, high-slope talent. Post a role anonymously, review anonymized shortlists of candidates who've opted in, and reveal identities only once there's mutual interest.",
  },
  {
    id: 6,
    heading: "How does anonymous hiring actually work?",
    text: "Roles and candidate profiles are posted without identifying details. Recruiters only gain visibility into a candidate once that candidate indicates interest in their specific role, and candidates only see a company's identity after a mutual match — keeping both sides confidential until there's a genuine fit.",
  },
  {
    id: 7,
    heading: "What types of roles and seniority levels is this best for?",
    text: "Stealth Jobs is purpose-built for confidential hiring across GTM and technical teams — from high-slope individual contributors through VP and C-suite searches, sensitive backfills, and other roles where discretion matters for either side.",
  },
  {
    id: 8,
    heading: "What makes Stealth Jobs different from a job board?",
    text: "Stealth Jobs isn't a job board. It's a curated platform that creates confidential connections between top-tier talent and roles that are largely never posted publicly — with a streamlined process and a more inclusive hiring environment on both sides.",
  },
  {
    id: 9,
    heading: "How does Stealth Jobs reduce hiring bias?",
    text: "Names and gender stay concealed until a match has been formed. That allows a fair, impartial evaluation of talent up front and promotes a more inclusive, unbiased hiring process.",
  },
  {
    id: 10,
    heading: "What's the approval criteria to join?",
    text: "We look for a proven track record, notable accomplishments, and alignment with the needs of growth-stage organizations. The goal is a curated community of high-calibre people, which is what keeps the environment secure and genuinely exclusive for candidates and companies alike.",
  },
  {
    id: 11,
    heading: "What does this cost?",
    text: "Stealth Jobs is free for both candidates and recruiters.",
  },
  {
    id: 12,
    heading: "How do you ensure high-quality matches for my search?",
    text: "When posting a role, recruiters select the job function, seniority, and requirements that matter most, so only candidates who genuinely match your criteria ever gain visibility into the opportunity.",
  },
];

export const footerLinkColumns = [
  {
    heading: "For Talent",
    links: [
      { label: "Browse Roles", href: "https://candidate.stealthjobs.co/", external: true },
      { label: "Create Profile", href: "https://candidate.stealthjobs.co/", external: true },
      { label: "Newsletter", href: "/newsletter" },
    ],
  },
  {
    heading: "For Recruiters",
    links: [
      { label: "Post a Role", href: "https://employer.stealthjobs.co/", external: true },
      { label: "How It Works", href: "/#how-it-works" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Contact", href: "mailto:support@stealthjobs.co" },
      { label: "Privacy & Security", href: "/privacy-policy" },
    ],
  },
];

// Matches the hero heading.
export const footerTagline =
  "Confidentially Connect Top Talent and Breakout Companies";

export const finalCtaCards = [
  {
    variant: "light",
    icon: <RocketOutlined />,
    heading: "Ready to explore new opportunities?",
    buttonLabel: "Apply Now",
    href: "https://candidate.stealthjobs.co/",
  },
  {
    variant: "dark",
    icon: <BankOutlined />,
    heading: "Ready to hire top talent?",
    buttonLabel: "I'm Recruiting",
    href: "https://employer.stealthjobs.co/",
  },
];
